import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil} from "lodash"
import {AsyncSelectField, SelectField} from 'components/selectField'
import {api} from 'services/api'

const params = {sortColumn: 'ref', sortDirection: 'asc'}

class OpportunitySelectField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      opportunities: null,
    }
  }

  UNSAFE_componentWillMount = () => {
    const {companyId} = this.props
    if (companyId) this.setWithCompany(companyId)
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const {companyId} = this.props

    if (nextProps.companyId) {
      if (isNil(companyId) || companyId !== nextProps.companyId) {
        this.setWithCompany(nextProps.companyId)
      }
    } else {
      this.setWithCompany(null)
    }
  }

  setWithCompany = (companyId) => {
    if (companyId) {
      // Load opportunities for company
      this.setState({opportunities: []})
      api.opportunity.get({companyId, ...params}, this.getFields()).then(response => {
        api.handleResponseNonYield(
            response,
            (key, data) => {
              this.setState({opportunities: data.result || []})
            },
            (key, message) => {
              console.error("Failed to load opportunities for company", message)
            }
        )
      })
    } else {
      this.setState({opportunities: null})
    }
  }

  getFields = () => {
    const {fields} = this.props
    return {
      default: true,
      ...fields,
    }
  }

  getOptions = (opportunities) => {
    return opportunities.map(opportunity => ({
      value: opportunity.id,
      label: `${opportunity.ref}: ${opportunity.desc}`,
      opportunity,
    }))
  }

  render() {
    const {...otherProps} = this.props
    const {opportunities} = this.state

    if (opportunities) {
      return <SelectField
          placeholder={'Find an Opportunity'}
          options={this.getOptions(opportunities)}
          {...otherProps} />
    } else {
      return <AsyncSelectField
          placeholder={'Find an Opportunity'}
          params={params}
          fields={this.getFields()}
          onLoad={api.opportunity.get}
          onOptions={this.getOptions}
          {...otherProps} />
    }
  }
}

OpportunitySelectField.propTypes = {
  companyId: propTypes.number,
  fields: propTypes.object,
}

export default OpportunitySelectField
